import React, { useState, useEffect } from "react";
import { ActionDetail } from "../../components/ui/dataTable/components/actionDetail";
import { Box } from "@mui/material";
import { MomentConvert } from "../../components/ui/moment/momentConvert";
import DataMaterialTable from "../../components/ui/dataTable/dataMaterialTable";
import { useTranslation } from "react-i18next";
import { getAllBranch } from "../../service/branchAPI";
import BreadcrumbsTitle from "../../components/ui/breadcrumbsTitle";
import StatusTable from "../../components/chip/statusTable";
import { TextTable } from "../../components/ui/textfield/textfieldCustom";
import dayjs from "dayjs";

function Branch() {
  const [rows, setRows] = useState([]);
  const { t } = useTranslation();
  const [columns, setColumns] = useState([]);
  const [exportColumnName, setExportColumnName] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);

  const fetchData = async () => {
    let dataColumns = [
      {
        accessorKey: "name",
        lexGrow: 1,
        header: t("global_name"),
        Cell: ({ cell }) => <TextTable props={{ text: cell.getValue() }} />,
      },
      {
        accessorKey: "update",
        lexGrow: 1,
        header: t("global_updated_at"),
        Cell: ({ cell }) => <TextTable props={{ text: cell.getValue() }} />,
      },
      {
        accessorKey: "status",
        enableSorting: false,
        header: t("global_status"),
        lexGrow: 1,
        Cell: ({ row, index }) => (
          <StatusTable props={{ status: row.original.status }} />
        ),
      },
      {
        accessorKey: "action",
        enableSorting: false,
        lexGrow: 1,
        header: "Action",
        sortable: false,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", gap: 2 }}>
            <ActionDetail params={row} detailPath={"/branch/detail/"} />
            {/* <ActionDuplicate dataProps={{ onDuplicate, row }} /> */}
          </Box>
        ),
      },
    ];
    let dataAPI = await getAllBranch();
    if (Array.isArray(dataAPI)) {
      let dataBox = dataAPI
        .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
        .map((item) => ({
          id: item.id,
          name: item.branch_lang?.name ?? "-",
          update: MomentConvert(item.branch_lang?.updated_at),
          status: item.status,
        }));
      //===== Start set header name export csv
      let headers = [];
      dataColumns.forEach((item) => {
        if (item.header !== "Image" && item.header !== "Action") {
          headers.push(item.header);
        }
      });
      const csvStringArray = [
        headers,
        ...dataBox.map((item) => [item.name, item.update, item.status]),
      ]
        .map((row) => row.join(","))
        .join("\n");

      setExportColumnName(csvStringArray);
      //===== End set header name export csv
      setRows(dataBox);
    }
    setColumns(dataColumns);
    setIsLoadingData(false);
  };

  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Box>
      <BreadcrumbsTitle
        props={{
          title: t("branch"),
        }}
      />
      <DataMaterialTable
        statusViewMode={true}
        rows={rows}
        exportColumnName={exportColumnName}
        fileName={t("branch") + ` ${dayjs().format("DD/MM/YYYY")}`}
        isLoadingData={isLoadingData}
        columns={columns}
        detailPath={"/branch/detail/"}
        createButton={t("branch")}
      />
    </Box>
  );
}

export default Branch;
